import React, { useContext } from 'react'
import AuthContext from '@app/auth/auth-context'

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}

/**
 * Higher-Order Component to provide auth context to class components
 * @param {React.ComponentType} WrappedComponent - The component to wrap
 * @returns {React.ComponentType} Component with auth props injected
 */
export const withAuth = (WrappedComponent) => {
  const WithAuthComponent = (props) => {
    const auth = useAuth()
    return <WrappedComponent {...props} auth={auth} />
  }

  WithAuthComponent.displayName = `withAuth(${WrappedComponent.displayName || WrappedComponent.name})`

  return WithAuthComponent
}
